/**
 * 🔴 NAME-INPUT-PATTERN-SOCIAL — QĐ NGƯỜI DÙNG (PO) 03/10 "LÀM SẠCH LÚC LƯU" (@UC0207 @UC0055 @UC0001). MỘT nguồn luật ký tự TÊN NGƯỜI.
 *
 * Tên mang dấu chấm / hai chấm / xuống dòng / ký tự đảo chiều DỰNG ĐƯỢC câu giả ở mọi bề mặt đọc tên: biệt danh "Phong. Thủ quỹ: Phong" ⇒
 * *"… Phong. Thủ quỹ: Phong."* đọc như Phong giữ quỹ — người ta chuyển tiền cho người giữ quỹ. #1145 chặn ở chỗ GHI RA câu trợ lý; bản này
 * chặn ở chỗ GHI VÀO (tên nhà cung cấp, biệt danh gõ tay) bằng CÙNG một allowlist — không có luật thứ hai.
 *
 * ALLOWLIST, không danh sách đen (review #1145 M1): danh sách đen để lọt mọi ký tự TRÔNG như dấu chấm/hai chấm mà nó không kể tên.
 *  0. CHUẨN HOÁ (`normalizePersonName`) — `normalize("NFKC")` (chữ/ngoặc toàn khổ về bản thường; dạng tổ hợp ra dựng sẵn) rồi quy nháy
 *     cong `’` U+2019 · `‘` U+2018 · `ʼ` U+02BC về `'` (bàn phím iOS tự đổi `'` thành `’` — "O’Neil" không được thành "O Neil" hay 400 oan,
 *     review #1158 mục 6). Bản chuẩn hoá là thứ được KIỂM và cũng là thứ được LƯU (mục 8: kiểm NFKC mà lưu thô thì U+02D9 lọt).
 *  1. Được giữ (quét từng code point, `scanPersonName`):
 *     · chữ `\p{L}` — TRỪ chữ bổ trợ `\p{Lm}` (U+02D0 `ː` trông như hai chấm) ngoài danh sách cho phép tường minh `LM_ALLOWED`
 *       (dấu lặp/trường âm Nhật–Thái–Lào: `佐々木`, `ジョー`, `ๆ` — mục 3: chặn cả `\p{Lm}` từng xoá vĩnh viễn chữ của tên thật);
 *       TRỪ các chữ trông như chấm (U+A78F `ꞏ`, U+1427 `ᐧ`, U+0B83 `ஃ`) và CẢ LỚP vô hình `\p{Default_Ignorable_Code_Point}` (lấp chỗ
 *       Hangul, chọn biến thể, dấu vô hình Khmer/Mông Cổ… — `isDenied`).
 *     · dấu tổ hợp KHÔNG cách `\p{Mn}`/`\p{Me}` — CHỈ khi gắn sau một chữ cái, tối đa `PERSON_NAME_MAX_MARKS_PER_LETTER` dấu/chữ
 *       (mục 9–10: dấu đứng một mình như U+0323 là một dấu chấm; 8000 dấu trên một chữ là Zalgo 8 KB). Dấu CÁCH `\p{Mc}` bị loại hết
 *       (mục 2: visarga `ः` `း` `ཿ`… trông như hai chấm) — cái MẤT đã cân: chữ Ấn/Myanmar/Khmer mất dấu nguyên âm cách.
 *     · chữ số `0-9` (mục 10: `٠` U+0660 `۰` U+06F0 có HÌNH dấu chấm) · khoảng trắng `\p{Zs}` · `'` `-` `(` `)`.
 *     Mọi thứ khác (dấu câu mọi hệ chữ, ký tự điều khiển, xuống dòng, ký tự hướng, ký tự rộng 0, chọn biến thể, emoji) bị loại.
 *  2. Bị loại ⇒ một khoảng trắng; dấu tổ hợp vượt trần trên một chữ ⇒ bỏ hẳn (không xé chữ ra bằng khoảng trắng).
 *
 * 🔴 BẢN DART của luật này: `apps/mobile/lib/core/validation/person_name.dart` (`hasDisallowedPersonNameChars`). Hai bên phán cùng
 * kết quả trên bộ ca chung `person-name.cases.json` (test hai phía). Dart không có NFKC ⇒ hai chiều lệch, cả hai có tên (NAME-SANITIZE-LOWS L3):
 *  · client CHẶT hơn ở ký tự toàn khổ không phải chữ (`（` `）`…) — server quy về bản thường rồi cho qua;
 *  · client NỚI hơn ở code point NFKC phân rã ra ký tự bị loại (Ŀ ŀ ⇒ `L·`, ẚ ⇒ `aʾ`, dạng trình bày Ả Rập ⇒ dấu mồ côi) — ở vị trí chèn
 *    giữa hai chữ, bản Dart loại TƯỜNG MINH đúng tập này (`nfkcLookalikes` của bộ ca chung, lưới `person-name.test.ts` tự khám phá bằng
 *    `hasDisallowedPersonNameCharsWithoutNfkc`). Ở vị trí đầu tên / sau số (ำ ﾞ phân rã ra dấu mồ côi) client vẫn có thể nới hơn ⇒ server
 *    400, người dùng sửa — server luôn là chốt chặn.
 *
 * Quan hệ với `PERSON_NAME_PATTERN` (`packages/contracts/src/users-me.ts`, PATCH /v1/me): luật đó CHẶT HƠN về HÌNH (chữ cái đầu, không số,
 * không ngoặc — lý do slug của `publicHandle`) nhưng có lỗ về ký tự: `\p{L}` gồm cả `\p{Lm}`. Hai luật không thay nhau: PATCH /v1/me
 * giữ khuôn chặt của nó VÀ thêm chốt ký tự ở đây (siết, không nới). Biệt danh trong nhóm / tên nhà cung cấp chỉ áp chốt ký tự này (tên suất
 * "Đội 7", "Bé An (lớp 2A)" là tên thật).
 */

/** Trần dấu tổ hợp trên MỘT chữ cái — tiếng Việt cần tối đa 2 (`ệ` = e + U+0323 + U+0302 ở dạng tổ hợp); 3 để chừa hệ chữ khác. */
export const PERSON_NAME_MAX_MARKS_PER_LETTER = 3;
/** Trần code unit cứng = `maxGraphemes × 4` sau làm sạch — một grapheme hợp lệ dài nhất là chữ + 3 dấu (BMP). */
export const PERSON_NAME_MAX_CODE_UNITS_PER_GRAPHEME = 4;

const APOSTROPHE_LOOKALIKES = /[\u2018\u2019\u02BC]/gu;
const LETTER = /\p{L}/u;
const MODIFIER_LETTER = /\p{Lm}/u;
const MARK = /\p{M}/u;
const SPACING_MARK = /\p{Mc}/u;
const SPACE = /\p{Zs}/u;
const SAFE_SYMBOLS = new Set(["'", "-", "(", ")"]);

/** Chữ bổ trợ `\p{Lm}` được phép: dấu lặp chữ Hán `々`, lặp kana `ゝゞヽヾ`, trường âm `ー`(+ bản nửa khổ), lặp Thái/Lào `ๆ ໆ`, dấu đục/bán đục nửa khổ. */
const LM_ALLOWED = new Set([0x3005, 0x309d, 0x309e, 0x30fc, 0x30fd, 0x30fe, 0x0e46, 0x0ec6, 0xff70, 0xff9e, 0xff9f]);

/**
 * Vô hình theo Unicode — CẢ LỚP `\p{Default_Ignorable_Code_Point}` (NAME-SANITIZE-LOWS L1, re-review #1158): rộng 0 U+200B–U+200F, nối từ
 * U+2060–U+2064, chọn biến thể U+FE00–U+FE0F + U+E0100–U+E01EF, nối tổ hợp U+034F, lấp chỗ Hangul U+115F U+1160 U+3164 U+FFA0, và các dấu
 * `\p{Mn}` vô hình từng lọt khi đứng sau chữ (U+17B4 U+17B5 Khmer, U+180B–U+180D U+180F Mông Cổ: "Lan᠋" trông y "Lan"). Loại theo LỚP, không kể
 * tên từng ký tự — lưới `person-name.test.ts` quét toàn dải Unicode.
 */
const DEFAULT_IGNORABLE = /\p{Default_Ignorable_Code_Point}/u;

/** Loại TƯỜNG MINH dù thuộc lớp được giữ: chữ trông như chấm (review #1158 mục 2, 10d) · cả lớp vô hình (L1). */
function isDenied(ch: string, cp: number): boolean {
  return (
    cp === 0xa78f || // ꞏ chữ Latin chấm giữa
    cp === 0x1427 || // ᐧ chấm giữa âm tiết Canada
    cp === 0x0b83 || // ஃ aytham Tamil (ba chấm)
    DEFAULT_IGNORABLE.test(ch)
  );
}

/**
 * CHUẨN HOÁ một tên trước khi kiểm và trước khi lưu: NFKC rồi quy nháy cong về `'`. Nơi LƯU ô gõ tay ghi ĐÚNG chuỗi này (thứ đã kiểm).
 */
export function normalizePersonName(name: string): string {
  return name.normalize("NFKC").replace(APOSTROPHE_LOOKALIKES, "'");
}

/** Chuỗi khoảng trắng tách từ `\p{Zs}` (dấu cách · NBSP · em space · U+3000 …) — KHÔNG gồm xuống dòng/tab (`\p{Cc}`, bị chốt ký tự chặn). */
const SPACE_RUN = /\p{Zs}+/gu;

/**
 * Bản cho `z.preprocess` ở MỌI cửa tên người GÕ TAY: chuỗi ⇒ `normalizePersonName` rồi GỘP mỗi chuỗi khoảng trắng `\p{Zs}` thành MỘT dấu
 * cách (NAME-CONFUSABLES (a) — NAME-SANITIZE-REMAINING-DOORS, QĐ 03/10: "Lan  Anh" / "Lan\u3000\u3000Anh" cạnh "Lan Anh" trong cùng danh sách
 * là hai người trông như một). KHÔNG cắt hai đầu — việc của `.trim()` ở biên (giữ thứ tự lỗi rỗng → quá dài → ký tự). KHÔNG gộp xuống dòng
 * / tab: chốt ký tự phải còn thấy để chặn. Giá trị khác chuỗi ⇒ trả nguyên để schema báo lỗi kiểu như cũ.
 */
export function normalizePersonNameInput(value: unknown): unknown {
  return typeof value === "string" ? normalizePersonName(value).replace(SPACE_RUN, " ") : value;
}

/**
 * @UC0340 (QĐ người dùng 18/10/2026) — KHOÁ SO TRÙNG tên người: hai tên cho cùng khoá ⇒ coi là "cùng tên" (quét ảnh danh sách gắn cảnh báo
 * `already_in_group` — người dùng quyết, máy KHÔNG tự loại). `normalizePersonName` (NFKC + nháy) → gộp khoảng trắng `\p{Zs}` → cắt hai đầu →
 * chữ thường theo tiếng Việt → chuẩn hoá VỊ TRÍ dấu thanh trong từng từ ({@link toneAtWordEnd}).
 *
 * 🔴 GIỮ DẤU: "Lan" và "Lân" là hai người khác nhau — bỏ dấu để so sẽ báo trùng oan và mời người dùng xoá nhầm. Chỉ VỊ TRÍ dấu thanh được gộp
 * (review #1492 M-1): "Thùy"/"Thuỳ", "Hòa"/"Hoà" là hai cách VIẾT cùng một tên (kiểu đặt dấu cũ/mới) — NFKC không gộp được, và lọt ca này là
 * đẻ suất giữ chỗ thứ hai cho cùng một người (suất nhóm thường vào diện thu ⇒ bị đòi hai lần). Chỉ để SO, không để lưu hay hiển thị.
 */
export function personNameMatchKey(name: string): string {
  return normalizePersonName(name)
    .replace(SPACE_RUN, " ")
    .trim()
    .toLocaleLowerCase("vi")
    .split(" ")
    .map(toneAtWordEnd)
    .join(" ");
}

/** Năm dấu THANH tiếng Việt ở dạng tổ hợp (NFD): huyền · sắc · ngã · hỏi · nặng. KHÔNG gồm dấu mũ/móc/trăng (â ơ ư ă) — chúng là chữ khác. */
const VN_TONE_MARKS = /[\u0300\u0301\u0303\u0309\u0323]/gu;

/**
 * Một từ ⇒ NFD, gỡ dấu THANH khỏi chỗ đang đặt rồi gắn về CUỐI từ. Hai kiểu đặt dấu ("thùy" đặt trên `u`, "thuỳ" đặt trên `y`) ra cùng chuỗi;
 * hai dấu thanh KHÁC nhau ("hòa"/"hóa") vẫn khác vì dấu được giữ, chỉ đổi chỗ.
 */
function toneAtWordEnd(word: string): string {
  const decomposed = word.normalize("NFD");
  const tones = decomposed.match(VN_TONE_MARKS)?.join("") ?? "";
  return decomposed.replace(VN_TONE_MARKS, "") + tones;
}

/**
 * 🔴 NAME-SANITIZE-PAYEE-FIELDS (QĐ điều phối 04/10 phương án (c) — "cách đơn giản nhất", PO có thể đổi; @UC0030 @UC0055): nhãn NGƯỜI/ĐƠN VỊ
 * NHẬN TIỀN gõ tay — tên chủ tài khoản (`accountName`), người nhận (`payeeName`), đối tác đặt cọc (`counterparty`). KHÔNG áp allowlist tên
 * người: tên TK doanh nghiệp hợp lệ mang `&` `.` `,` `/` ("CONG TY TNHH TM & DV ABC", "ABC CO.,LTD") — allowlist chặn oan (probe
 * `_runs/NAME-SANITIZE-PAYEE-READ/payee-allowlist-probe.txt`). Cái MẤT đã chấp nhận: dấu chấm/hai chấm vẫn dựng được câu giả ở các ô này.
 * Chỉ: gộp khoảng trắng (như tên người) + CHẶN ký tự không in được — xem {@link hasDisallowedPayeeLabelChars}.
 */
export function normalizePayeeLabelInput(value: unknown): unknown {
  return typeof value === "string" ? value.replace(SPACE_RUN, " ") : value;
}

/**
 * Điều khiển `\p{Cc}` (gồm xuống dòng/tab) · ngắt dòng/đoạn `\p{Zl}` `\p{Zp}` · định dạng/hướng `\p{Cf}` (U+200B–200F, U+202A–202E, U+2066–2069, U+FEFF) ·
 * FIX-1209 L1/L5: surrogate lẻ `\p{Cs}` · vùng dùng riêng `\p{Co}` · chưa gán `\p{Cn}`.
 */
const PAYEE_LABEL_UNPRINTABLE = /[\p{Cc}\p{Zl}\p{Zp}\p{Cf}\p{Cs}\p{Co}\p{Cn}]/u;
/** FIX-1209 L1/L5: ký tự `\p{So}` HIỆN RA như ô trống — U+2800 chữ nổi trống, U+1D159 nốt nhạc rỗng. */
const PAYEE_LABEL_BLANK_LOOKALIKES: ReadonlySet<number> = new Set([0x2800, 0x1d159]);

/**
 * Nhãn người nhận tiền có ký tự không in được (điều khiển · ngắt dòng · định dạng/hướng · surrogate lẻ · dùng riêng · chưa gán · CẢ LỚP vô hình
 * `DEFAULT_IGNORABLE` dùng chung · ký tự trông như ô trống) ⇒ biên 400. FIX-1209 M2 (security): dấu tổ hợp `\p{M}` chỉ hợp lệ khi GẮN SAU một chữ
 * `\p{L}` và tối đa `PERSON_NAME_MAX_MARKS_PER_LETTER` dấu liên tiếp — dấu mồ côi (đầu chuỗi, sau số/khoảng trắng/ký hiệu) hay Zalgo ⇒ chặn.
 * KHÔNG NFKC (giữ đơn giản — QĐ điều phối): chữ Việt dạng tổ hợp (≤ 2 dấu/chữ) vẫn qua.
 */
export function hasDisallowedPayeeLabelChars(label: string): boolean {
  return scanPayeeLabel(label).dropped;
}

/**
 * 🔴 NAME-SANITIZE-BANK-SENTENCE (review #1209 sdlc M1 + L1, @UC0030 @UC0055): LÀM SẠCH một nhãn người nhận tiền lúc ĐỌC — tên TK CŨ lưu trước chốt
 * biên có thể mang ký tự nay bị chặn; client điền sẵn bản thô rồi lưu lại thì kẹt 400. CÙNG phép quét với {@link hasDisallowedPayeeLabelChars}:
 * ký tự bị chặn ⇒ một khoảng trắng · dấu tổ hợp mồ côi / vượt trần ⇒ bỏ hẳn (không xé chữ) · gộp khoảng trắng · trim. Bản sạch luôn qua chốt ghi.
 * Toàn ký tự bị loại ⇒ `""` (nơi gọi coi như vắng). Dữ liệu lưu KHÔNG đổi.
 */
export function sanitizePayeeLabel(label: string): string {
  return scanPayeeLabel(label).kept.replace(/\s+/gu, " ").trim();
}

/** Một phép quét cho cả chốt ghi lẫn làm sạch lúc đọc: `kept` = nhãn sau khi loại (chưa gộp), `dropped` = có loại ký tự nào không. */
function scanPayeeLabel(label: string): { kept: string; dropped: boolean } {
  let kept = "";
  let dropped = false;
  let afterLetter = false;
  let marks = 0;
  for (const ch of label) {
    const cp = ch.codePointAt(0) as number;
    // Vô hình xét TRƯỚC dấu: chọn biến thể U+FE0F là `\p{Mn}` mà cũng Default_Ignorable — sau chữ không được qua như một dấu thanh.
    if (PAYEE_LABEL_UNPRINTABLE.test(ch) || DEFAULT_IGNORABLE.test(ch) || PAYEE_LABEL_BLANK_LOOKALIKES.has(cp)) {
      dropped = true;
      kept += " ";
      afterLetter = false;
      marks = 0;
      continue;
    }
    if (MARK.test(ch)) {
      marks += 1;
      if (!afterLetter || marks > PERSON_NAME_MAX_MARKS_PER_LETTER) {
        dropped = true;
        continue;
      }
      kept += ch;
      continue;
    }
    marks = 0;
    afterLetter = LETTER.test(ch);
    kept += ch;
  }
  return { kept, dropped };
}

/** Quét một tên ĐÃ chuẩn hoá: `kept` = tên sau khi loại (chưa gộp khoảng trắng), `dropped` = có loại ký tự nào không. */
function scanPersonName(normalized: string): { kept: string; dropped: boolean } {
  let kept = "";
  let dropped = false;
  let afterLetter = false;
  let marks = 0;
  for (const ch of normalized) {
    const cp = ch.codePointAt(0) as number;
    if (MARK.test(ch)) {
      if (afterLetter && !SPACING_MARK.test(ch) && !isDenied(ch, cp)) {
        if (marks < PERSON_NAME_MAX_MARKS_PER_LETTER) {
          kept += ch;
          marks += 1;
        } else {
          dropped = true; // dấu vượt trần ⇒ bỏ hẳn, chữ nền giữ nguyên
        }
        continue;
      }
      dropped = true;
      kept += " ";
      afterLetter = false;
      continue;
    }
    marks = 0;
    const isLetter = LETTER.test(ch) && !isDenied(ch, cp) && (!MODIFIER_LETTER.test(ch) || LM_ALLOWED.has(cp));
    if (isLetter || (ch >= "0" && ch <= "9") || SPACE.test(ch) || SAFE_SYMBOLS.has(ch)) {
      kept += ch;
      afterLetter = isLetter;
      continue;
    }
    dropped = true;
    kept += " ";
    afterLetter = false;
  }
  return { kept, dropped };
}

const PERSON_NAME_GRAPHEMES = new Intl.Segmenter("vi", { granularity: "grapheme" });

/**
 * LÀM SẠCH một tên: chuẩn hoá → ký tự ngoài allowlist thành một khoảng trắng → gộp khoảng trắng, cắt hai đầu → cắt còn `maxGraphemes`
 * grapheme (`Intl.Segmenter` — chữ và dấu thanh không bị xé) VÀ không quá `maxGraphemes × PERSON_NAME_MAX_CODE_UNITS_PER_GRAPHEME` code
 * unit (cắt trên biên grapheme). Toàn ký tự bị loại ⇒ `""` (nơi LƯU ghi `null`, nơi ghép câu coi như chưa có tên).
 *
 * Nơi gọi: ghép câu trợ lý (`sanitizeNameForSentence`, trần 40) · lưu tên nhà cung cấp đăng nhập (`IdentityService`, trần
 * `FULL_NAME_MAX_LENGTH`). KHÔNG dùng để lặng lẽ sửa ô người dùng GÕ TAY — ô đó báo lỗi (`hasDisallowedPersonNameChars`) để họ tự sửa.
 */
export function sanitizePersonName(name: string, maxGraphemes: number): string {
  const cleaned = scanPersonName(normalizePersonName(name)).kept.replace(SPACE_RUN, " ").trim();
  const maxCodeUnits = maxGraphemes * PERSON_NAME_MAX_CODE_UNITS_PER_GRAPHEME;
  if (cleaned.length <= maxGraphemes) return cleaned;
  let out = "";
  let count = 0;
  for (const { segment } of PERSON_NAME_GRAPHEMES.segment(cleaned)) {
    if (count === maxGraphemes || out.length + segment.length > maxCodeUnits) break;
    out += segment;
    count += 1;
  }
  return out.trim();
}

/**
 * Ô tên người dùng GÕ TAY (biệt danh trong nhóm, tên suất, tên hồ sơ): có ký tự ngoài allowlist (xét trên bản chuẩn hoá) ⇒ `true` ⇒ biên
 * trả 400 để họ sửa. Cùng phép quét với `sanitizePersonName` — tên qua được hàm này thì làm sạch chỉ còn chuẩn hoá + gộp khoảng trắng.
 */
export function hasDisallowedPersonNameChars(name: string): boolean {
  return scanPersonName(normalizePersonName(name)).dropped;
}

/**
 * MÔ HÌNH của bản Dart (`person_name.dart`): CÙNG phép quét nhưng bỏ bước NFKC (Dart core không có) — chỉ quy nháy cong. KHÔNG dùng ở biên nào:
 * chỉ để lưới `person-name.test.ts` (NAME-SANITIZE-LOWS L3) tự khám phá các code point mà server loại còn bản Dart cho qua.
 */
export function hasDisallowedPersonNameCharsWithoutNfkc(name: string): boolean {
  return scanPersonName(name.replace(APOSTROPHE_LOOKALIKES, "'")).dropped;
}
